<template>
  <div class="print-diet-modal__footer">
    <div v-if="limited" class="print-diet-modal__limit">
      <p v-if="remaining > 0">
        Pozostała liczba jadłospisów do wydrukowania w wersji akademickiej:
        {{ remaining }}
      </p>
      <p v-else class="print-diet-modal__limit-warning">
        Wykorzystałeś już limit wydrukowanych jadłospisów w wersji akademickiej, przejdź na wyższy
        plan.
      </p>
    </div>
    <div class="print-diet-modal__actions">
      <Button color="gray" @click="emit('close')">Anuluj</Button>
      <Button v-if="!limitExceeded && !testPrint" @click="emit('download')">Pobierz PDF</Button>
      <Button v-if="limitExceeded" color="error" @click="emit('upgrade')">Zmień plan</Button>
      <Button v-if="testPrint" color="gray" @click="emit('sample')">Wydruk przykładowy</Button>
      <Button v-if="testPrint" @click="emit('upgrade')">Wykup pakiet</Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { Button } from '@/components/ui'

  defineProps<{
    limited: boolean
    limitExceeded: boolean
    remaining: number
    testPrint: boolean
  }>()
  const emit = defineEmits<{
    close: []
    download: []
    sample: []
    upgrade: []
  }>()
</script>

<style scoped>
  .footer {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .footer__limit {
    font-size: 12px;
    color: var(--color-text-text-tertiary-600);
  }

  .footer__warning {
    color: var(--color-error-600);
  }

  .footer__actions {
    display: flex;
    gap: 12px;
    margin-left: auto;
  }
</style>
